var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading109_container"},[_c('div',{staticClass:"holder"},[_c('div',{staticClass:"candle"},[_c('div',{staticClass:"blinking-glow"}),_c('div',{staticClass:"thread"}),_c('div',{staticClass:"glow"}),_c('div',{staticClass:"flame"})])])])
}]

export { render, staticRenderFns }